<lib-cdw-ou-collection-edit
  #ouCollectionEdit
  *ngIf="!isLoading && (currentOrgUnitCollection || selectedOrgUnitCollectionId === 'new')"
  [ouCollection]="currentOrgUnitCollection"
  [ouCollectionOus]="currentOrgUnitCollectionOUs"
  [ouSelectOptions]="orgUnitSelectOptions"
  (submitOuCollectionEdit)="onSubmitEdit($event)"
  (cancelOuCollectionEdit)="onCancelEdit()"
  (deleteOuCollection)="onDeleteOrgUnitCollection()"
></lib-cdw-ou-collection-edit>
